var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6F6F6F",
    d: "M6.2 17.4V8.8h2.3l.3-3H6.2V4.4c0-.8 0-1.2 1.1-1.2h1.5v-3H6.4C3.6.2 2.6 1.7 2.6 4.1v1.7H.8v3h1.8v8.6h3.6z",
    fillRule: "evenodd"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5IiBoZWlnaHQ9IjE4IiB2aWV3Qm94PSIwIDAgOSAxOCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIjNkY2RjZGIiBkPSJNNi4yIDE3LjRWOC44aDIuM2wuMy0zSDYuMlY0LjRjMC0uOCAwLTEuMiAxLjEtMS4yaDEuNXYtM0g2LjRDMy42LjIgMi42IDEuNyAyLjYgNC4xdjEuN0guOHYzaDEuOHY4LjZoMy42eiIvPjwvZz48L3N2Zz4=";
export { SvgIconFb as ReactComponent };